import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CostCenter,
  GrantAccessPayload,
  KpiArea,
  User,
  UserAccess,
} from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/users`;

  list(): Observable<User[]> {
    return this.http.get<User[]>(this.baseUrl);
  }

  costCenters(): Observable<CostCenter[]> {
    return this.http.get<CostCenter[]>(`${this.baseUrl}/cost-centers`);
  }

  kpiAreas(): Observable<KpiArea[]> {
    return this.http.get<KpiArea[]>(`${this.baseUrl}/kpi-areas`);
  }

  access(accessId: number): Observable<UserAccess[]> {
    return this.http.get<UserAccess[]>(`${this.baseUrl}/${accessId}/access`);
  }

  grantAccess(payload: GrantAccessPayload): Observable<UserAccess[]> {
    return this.http.post<UserAccess[]>(
      `${this.baseUrl}/${payload.accessId}/access`,
      payload
    );
  }

  revokeAccess(
    accessId: number,
    costCenterId: number,
    areaId: number
  ): Observable<UserAccess[]> {
    return this.http.delete<UserAccess[]>(
      `${this.baseUrl}/${accessId}/access/${costCenterId}/${areaId}`
    );
  }

  updateDailyReporting(accessId: number, value: boolean): Observable<User> {
    return this.http.patch<User>(
      `${this.baseUrl}/${accessId}/daily-reporting`,
      { accessDailyReporting: value }
    );
  }

  deleteUser(accessId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${accessId}`);
  }
}
